<script setup lang="ts" name="DropdownDateOption">
import { getDateYear, getTimeFromDate } from '~/features/useDates';

defineProps<{
  date: string | Date;
  active?: boolean;
}>();
</script>

<template>
  <span>{{ getDateYear(date) }}</span>
  <span
    class="ml-3 text-charcoal-6 group-hover:text-primary-8"
    :class="{ 'text-primary-8': active }"
  >
    {{ getTimeFromDate(date) }}
  </span>
</template>
